import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Harmless?",
  "description": "",
  "published": "2006-08-09T00:00:00.000Z",
  "redirect_from": ["/blog/harmless/swizec/390"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Firstly, as you may have noticed the comic is still not up even after I promised for it to be in its rightful position of being up. This is due to many reasons, one is that I now effectively have two jobs, one full time and one part time... moneys are important. Another reason is that the computer all of the work is done on decided to be a downright bastard and have a disk fault right where all the panels were, or at least most of them, so I ended up having to redo a big part of the comic... which I am now in the process of redoing as fast as possible.`}</p>
    <p>{`Now that that's out of the way, today a great and quiet awesome video has been found by a member of the `}<a parentName="p" {...{
        "href": "http://cad-forums.com"
      }}>{`CAD`}</a>{` forums and that video... shows how one can manipulate time. Of course it's not really time manipualtion but it does have the same effect. How to make the device, how to use it and what it actually does is greatly explained on the `}<a parentName="p" {...{
        "href": "http://cre.ations.net/creation/44"
      }}>{`website`}</a>{`. You really should go and have a look, `}<a parentName="p" {...{
        "href": "http://cre.ations.net/creation/44"
      }}>{`it's`}</a>{` worth it.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      